const now = new Date();
const in15Mins = new Date(now.getTime() + 15 * 60000);
const tomorrow = new Date(now.getTime() + 24 * 60 * 60000);
const in3Days  = new Date(now.getTime() + 3 * 24 * 60 * 60000);
const in1Week  = new Date(now.getTime() + 7 * 24 * 60 * 60000);

const formatDate = (d) => {
  const year  = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day   = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const formatTime = (d) => {
  let hours = d.getHours();
  let minutes = d.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  return `${hours}:${minutes} ${ampm}`;
};

export const mockWebinars = [
  {
    id: 'web-1',
    title: "The Art of Legacy Writing",
    seriesTitle: "Legacy Builders Series",
    isRecurring: true,
    recurrencePattern: "Every Tuesday",
    date: formatDate(tomorrow),
    time: formatTime(tomorrow),
    duration: "60 min",
    speaker: "Dr. Julian Thorne",
    speakerBio: "Renowned biographer and grief counselor with 20 years experience helping families preserve stories.",
    description: "Discover how to distill a lifetime of memories into a compelling narrative that will endure for generations.",
    image: "https://images.unsplash.com/photo-1455390582262-044cdead277a?q=80&w=1973&auto=format&fit=crop",
    registrants: 142,
    isLive: false,
    category: "Writing",
    deceasedName: "General Legacy",
    familyName: "Community",
    location: "Virtual",
    workPlace: "OneFinalLegacy Academy",
    monetization: { isFree: true, price: 0, currency: 'USD', discountPercent: 0, hasReplay: true },
    greenRoom: { enabled: true, openMinutesBefore: 30 },
  },
  {
    id: 'web-2',
    title: "Digital Asset Protection",
    seriesTitle: null,
    isRecurring: false,
    date: formatDate(now),
    time: formatTime(in15Mins),
    duration: "45 min",
    speaker: "Sarah Vance, JD",
    speakerBio: "Leading expert in digital estate law, advising families on social accounts and crypto assets.",
    description: "A technical and legal deep-dive into securing social accounts, passwords, and crypto assets after death.",
    image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?q=80&w=1470&auto=format&fit=crop",
    registrants: 101,
    isLive: true,
    category: "Legal",
    deceasedName: "General Planning",
    familyName: "Legal Dept",
    location: "Global",
    workPlace: "Tech & Law Hub",
    monetization: { isFree: false, price: 29, currency: 'USD', discountPercent: 10, hasReplay: true },
    greenRoom: { enabled: true, openMinutesBefore: 15 },
    platformConfig: { platform: 'native', credentials: { rtmpUrl: 'rtmp://stream.onefinallegacy.com/live', streamKey: 'sk-web2-live' } },
  },
  {
    id: 'web-4',
    title: "Communal Healing Circles",
    seriesTitle: "Community Support",
    isRecurring: true,
    recurrencePattern: "Weekly",
    date: formatDate(in3Days),
    time: "2:00 PM",
    duration: "90 min",
    speaker: "Marcus Vane",
    speakerBio: "Grief support specialist and facilitator of healing communities worldwide.",
    description: "A shared space for collective mourning and mutual support among bereaved community members.",
    image: "https://images.unsplash.com/photo-1516589174184-c685ca33d2b0?q=80&w=2070&auto=format&fit=crop",
    registrants: 85,
    isLive: false,
    category: "Wellness",
    deceasedName: "All Loved Ones",
    familyName: "Bereaved Hearts",
    location: "Online",
    workPlace: "Healing Sanctuary",
    monetization: { isFree: true, price: 0, currency: 'USD', discountPercent: 0, hasReplay: false },
    greenRoom: { enabled: false },
  },
  {
    id: 'web-5',
    title: "Estate Planning Essentials",
    seriesTitle: "Legacy Wealth",
    isRecurring: false,
    date: formatDate(in1Week),
    time: "10:00 AM",
    duration: "120 min",
    speaker: "Robert Chen",
    speakerBio: "Senior Estate Attorney with expertise in cross-border inheritance law.",
    description: "Navigating the complexities of wills, trusts, and final arrangements for modern families.",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?q=80&w=2070&auto=format&fit=crop",
    registrants: 230,
    isLive: false,
    category: "Planning",
    deceasedName: "Estate Holders",
    familyName: "Family Trusts",
    location: "Global",
    workPlace: "Legacy Advisors",
    monetization: { isFree: false, price: 49, currency: 'USD', discountPercent: 0, hasReplay: true },
    greenRoom: { enabled: true, openMinutesBefore: 20 },
  }
];